import { EntityTypeEnum, WorkspaceWindowTypeEnum } from '@mark43/cad-api';
import { useWorkspaceStore } from '../../panels/use-workspace-store';
import { assertNonNull } from '../../queues/utils/assert-non-null';

export function useEventQueueWorkspacePanel() {
    const workspacePanels = useWorkspaceStore().getActivePanels();

    const foundEventQueueWorkspacePanel = workspacePanels.find(
        (panel) =>
            panel.workspacePanelType === WorkspaceWindowTypeEnum.QUEUE.name &&
            panel.queue?.dataEntityType === EntityTypeEnum.CAD_AGENCY_EVENT.name
    );

    assertNonNull(
        foundEventQueueWorkspacePanel,
        'Workspace for queue and entity type CAD_AGENCY_EVENT not found'
    );

    return foundEventQueueWorkspacePanel;
}
